import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import theme from '../../styles/theme';
import { Icon } from '../Icon';
// TODO: For right now, I made this a square. If we end up wanting to use this elsewhere, we can update props to change this to be whatever desired shape or aspect ratio.
const imageUnavailableStyles = css `
  align-items: center;
  aspect-ratio: 1/1;
  background-color: ${theme.colors.gray200};
  color: ${theme.colors.gray400};
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: ${theme.spacing.base};
  width: 100%;
`;
const labelStyles = css `
  ${theme.typeStyles.bodySmallStyles}
  color: ${theme.colors.gray400};
`;
const ImageUnavailable = () => (_jsxs("div", Object.assign({ css: imageUnavailableStyles }, { children: [_jsx(Icon, { size: "medium", type: "caption" }), _jsx("span", Object.assign({ css: labelStyles }, { children: "Image unavailable" }))] })));
export { ImageUnavailable };
